import React, { FC, PropsWithChildren } from "react";
import classNames from "classnames";

type Props = {
  className?: string;
};

export const NavigationContainer: FC<PropsWithChildren<Props>> = ({
  children,
  className,
}) => (
  <div
    className={classNames(
      "grid grid-cols-1 text-regular",
      "sm:grid-cols-2 sm:gap-x-5",
      "md:grid-cols-4",
      "xxl:grid-cols-[32.5%,1fr,1fr,1fr,1fr]",
      className,
    )}
  >
    {children}
  </div>
);
